import { phaseApplicabilityAllows, PHASE_CONTEXT_VERSION } from '@/services/domain/phaseApplicability';

/** Configuration shows shared definitions plus any selected participating phase. */
export function configurationMatchesPhaseView(definition, phaseIds = [], domainApplicability) {
  if (!phaseIds.length) return true;
  try {
    return phaseIds.some(phaseId => phaseApplicabilityAllows(definition?.phaseApplicability,
      { version: PHASE_CONTEXT_VERSION, status: 'known', phaseId }, domainApplicability));
  } catch {
    // Invalid legacy configuration must remain reachable for repair.
    return true;
  }
}

/** Reorder visible definitions within their existing slots; never discard hidden ones. */
export function reorderVisibleDefinitions(all, visibleIds, activeId, overId) {
  const visible = new Set(visibleIds);
  const items = all.filter(item => visible.has(item.id));
  const from = items.findIndex(item => item.id === activeId);
  const to = items.findIndex(item => item.id === overId);
  if (from < 0 || to < 0 || from === to) return all;
  const [item] = items.splice(from, 1);
  items.splice(to, 0, item);
  let index = 0;
  return all.map(item => visible.has(item.id) ? items[index++] : item);
}
